import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faEdit, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../Layout/Loader';
import PrimeTable from '../../PrimeTable/PrimeTable';
import { useTranslation } from 'react-i18next';
import mainAxios from '../../../services/mainAxios';
import moment from 'moment';
import { useAppContext } from '../../../AppContext';
import ExchangeRateHistory from './ExchangeRateHistory';
import { Dialog } from 'primereact/dialog';

const Currencies = () => {
    const [currencies, setCurrencies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState({id:null,open:false});

    const { t } = useTranslation('translations');
    const {
        user: [user],
        selectedCompany = { selectedCompany },
        company: [fullCompany],
    } = useAppContext();

    const getCurrencies = () => {
        setLoading(true);
       return mainAxios.get('/api/exchange-rates/getAll')
            .then(res => {
                console.log({rest:res})
                setCurrencies(res.data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching currencies:', error);
                setLoading(false);
            });
    };

    useEffect(() => {
        getCurrencies();
    }, []);


const manualScheduler = () => {
    setLoading(true);
    return mainAxios.get('/api/exchange-rates')
        .then(() => {
            return getCurrencies();
        })
        .catch(error => {
            console.error('Error triggering scheduler:', error);
            setLoading(false);
        });
};


    const formatModifiedDate = (dateArray) => {
        if (!dateArray) return "";
        const [year, month, day, hour, minute, second] = dateArray;
        return moment({ year, month: month - 1, day, hour, minute, second }).format("DD/MM/YYYY HH:mm:ss");
    };

    const columns = [
        {
            header: t('customers.name') + " "+ "EN",
            field: 'monedhaEn',
            filter: true,
            style: { minWidth: "100px", maxWidth: "100px" },
        },
        {
            header: t('customers.name') + " "+ "AL",
            field: 'monedhaAl',
            filter: true,
            style: { minWidth: "100px", maxWidth: "100px" },
        },
        {
            header: t('item.code'),
            field: 'code',
            filter: true,
            style: { minWidth: "100px", maxWidth: "100px" },

        },
        {
            header: t('invoice.value'),
            field: 'value',
            style: { minWidth: "100px", maxWidth: "100px" },
            filter: true,
        },

        {
            header: t("common.lastUpdate"),
            field: "modifiedDate",
            style: { minWidth: "100px", maxWidth: "100px" },
            body: (currencies) => formatModifiedDate(currencies?.modifiedDate),
        },
        {
            header: t(["home.actions"]),
            field:"actions",
            style:{ minWidth: '200px', maxWidth:"200px" },
            body: (currency) => (
              <>
                <div
                  className="nav-link p-0 text-primary"
                onClick={() => setOpen({currency,open:true})}
                style={{ cursor: "pointer" }}
                >
      
                  <FontAwesomeIcon icon={faChartLine} className="mr-1" />
                  {t("common.exRateHistory")}
                </div>
              </>
            ),
          },
    ];

    return (
        <>
            <div className="d-flex justify-content-between align-items-center my-2">
                <h3 className="m-0 p-0 d-flex align-items-center">
                    <span className='mr-3'>{t('navbar.currencies')}</span>
                </h3>
                {user?.role?.id == 1 && (
                <button onClick={manualScheduler} className="btn btn-sm btn-primary">
                    <FontAwesomeIcon icon={faSyncAlt} className="mr-2" />
                    {t("status.refresh")}
                </button>
            )}
            </div>
            <Dialog
                header={
                    <span>
                        {t("common.exRateHistory")}: <span style={{ color: 'green' }}>{open.currency?.monedhaEn}</span>
                    </span>
                }
                visible={open.open}
                onHide={() => setOpen({currency:null,open:false})}
                style={{ width: "750px", height: "500px" }}
                breakpoints={{ "960px": "75vw", "641px": "100vw" }}
            >
                {open?.open &&
                 <ExchangeRateHistory
                    onDataSuccess={()=>{
                        setOpen({currency:null,open:false});
                    }}
                    currency={open?.currency}
                    />
                }
            </Dialog>

            {currencies ? (
                <div className="card border-0 shadow">
                    <div className="card-body">
                        <PrimeTable
                            columns={columns}
                            loading={loading}
                            value={currencies}
                            simpleTable={true}
                            reorderableColumns={true}
                            showFilters={true}
                            filterDisplay={'row'}
                            showSelectColumns={false}
                        />
                    </div>
                </div>
            ) : (
                <Loader />
            )}
        </>
    );
};

export default Currencies;
